import { CallChooser } from "@/components/CallChooser/CallChooser";
import { Link } from "@medoma/components/Link/Link";
import styles from "@/pages/ambulating/patients/$patientId/CallPatientOrRelatives.module.scss";
import PhoneIcon from "@medoma/components/icons/PhoneIcon";
import { useLingui } from "@lingui/react/macro";
import type { LocalizedPhoneNumber } from "@medoma/models/phoneNumbers";
import { useUserProfile } from "@/api/Users";
import { organizationSchema } from "@medoma/models/organizations";

export const CallPatientOrRelatives = ({
  patient,
  relatives,
}: {
  patient: {
    name: string;
    phoneNumber?: LocalizedPhoneNumber | null | undefined;
  };
  relatives: ReadonlyArray<{ name: string; phoneNumber: LocalizedPhoneNumber }>;
}) => {
  const { t } = useLingui();
  const { organization } = useUserProfile();
  return patient.phoneNumber && relatives.length >= 1 ? (
    <CallChooser
      contacts={[
        {
          name: patient.name,
          phoneNumber: patient.phoneNumber,
        },
        ...relatives,
      ]}
    />
  ) : patient.phoneNumber ? (
    <Link
      aria-label={t`Ring patienten`}
      className={styles.phoneLink}
      type={
        organization === organizationSchema.enum.hahag ||
        organization === organizationSchema.enum.ksgr
          ? "microsoft-teams-phone-call"
          : "phone"
      }
      to={patient.phoneNumber}
    >
      <PhoneIcon />
    </Link>
  ) : // Workaround for scenario where patient has no phone number.
  null;
};
